/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { myRoleV4ListApiResponseObjectV4Schema } from './myRoleV4ListApiResponseObjectV4Schema'

export const meGetRolesStatus200Schema = myRoleV4ListApiResponseObjectV4Schema.describe(
  'Typed variant of EP.Models.ViewModels.ApiResponseObjectV4, used in `[ProducesResponseType]` so Swagger renders\r\nthe real `result` schema instead of the bare `object` (which the UI shows as `"string"`).\r\nWire shape is identical to the untyped envelope — this only carries the type for the schema generator.'
)

export const meGetRolesResponseSchema = meGetRolesStatus200Schema
